var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotx48 = function SvgDotx48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1709 178q19 8 19 29v1681q0 14-9 23t-23 9H512q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-288H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h152V160q0-14 9-23t23-9h1209q7 0 13 3m-38 1629V384H384v224h536q30 0 51 21t21 51v720q0 30-21 51t-51 21H384v288M1696 277l-96-34v1517q0 14-9 23t-23 9H512v96h1184m-640-640h384v64h-384m0-224h384v64h-384m0-224h384v64h-384m0-224h384v64h-384m-633 328q-1-8-2-15t-2-12l-68-327h-91l111 468h105l71-309q1-4 3-13 1-10 3-20 1-11 3-20t3-14q1 4 3 13 1 8 3 18 1 10 3 20 1 9 3 15l75 310h104l110-468h-89l-63 324q-6 34-9 58-2-18-4-33-3-15-6-27l-78-322h-98l-76 327q-2 11-5 28-4 17-6 28 0-12-3-29",
    className: "dotx_48_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M1677 229q14 0 23 10 9 9 9 22v1606q0 13-9 23-9 9-23 9H528q-14 0-23-9-9-10-9-23v-91H396q-14 0-23-9-9-10-9-23V292q0-14 9-23t23-9h127q1-13 10-22t22-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1728 256v1632q0 14-9 23t-23 9H512q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23V304q0-14 9-23t23-9h1184q14 0 23 9t9 23v1456q0 14-9 23t-23 9H512v96h1184V256m-128 1504V304H384v1456z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M1600 243v141H352V160q0-14 9-23t23-9h1209q2 0 4 1h3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M1709 178q19 8 19 29v81l-128-45V129m0 255H352v-32h1248z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M1440 768v64h-384v-64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M1440 928v64h-384v-64z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M1440 1088v64h-384v-64z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M1440 1248v64h-384v-64z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M920 1472H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h720q30 0 51 21t21 51v720q0 30-21 51t-51 21"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M423 1160q3 17 3 29 2-11 6-28 3-17 5-28l76-327h98l78 322q3 12 6 27 2 15 4 33 3-24 9-58l63-324h89l-110 468H646l-75-310q-2-6-3-15-2-10-3-20-2-10-3-18-2-9-3-13-1 5-3 14t-3 20q-2 10-3 20-2 9-3 13l-71 309H371L260 806h91l68 327q1 5 2 12t2 15"
  })));
};
export default SvgDotx48;